import React from "react";
import LicenceModel from "../../models/LicenceModel";
import { dateFormatted, DAY } from "../../helpers/timeHelpers";
import { TableList } from "../../app/components/TableList";

import classes from './index.module.scss';

type LicenceTableDataProps = {
  licenceList: LicenceModel[],
  onSelect: (id: number) => void,
  selectedId: number;
}

function getStatus(licence: LicenceModel) {
  const now = +new Date();

  if (!licence.expirationDate) {
    return 'Active';
  }

  const expiration = +new Date(licence.expirationDate);

  if (expiration < now) {
    return 'Expired'
  }

  if (expiration - now < DAY * 10) {
    return 'Expiring Soon';
  }

  return 'Active';
}

const LicenceTableData = (props: LicenceTableDataProps) => {
  const { licenceList, onSelect, selectedId } = props;
  const columns = [
    { field: 'name', headerName: 'Name' },
    { field: 'expirationDate', headerName: 'Expiration Date' },
    { field: 'status', headerName: 'Status' },
  ];

  const rows = licenceList.map((licence) => {
    return {
      id: licence.id,
      name: licence.name,
      expirationDate: licence.expirationDate ? dateFormatted(licence.expirationDate, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }) : '',
      status: getStatus(licence),
    }
  });

  return (
    <TableList
      classes={{ table: classes.rightColumn }}
      columns={columns}
      rows={rows}
      selectRow={onSelect}
      selectedId={selectedId}
    />
  );
}

export default LicenceTableData;